import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import { contentRegisterResourceTypes } from 'components/hooks/contentRegisterQueries';

import AppWrapper from 'components/apps/AppWrapper';
import ContentRegister from 'components/contentRegister/components/ContentRegister';
import { ContentRegisterContext } from 'components/contentRegister/contexts/ContentRegisterContext';
import { currentActorContextPropsStructure } from 'components/contexts/CurrentActor';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ContentRegisterContext.Provider value={{ ...wrappedProps }}>
          <ContentRegister />
        </ContentRegisterContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  contextProps: PropTypes.shape({
    actors: PropTypes.exact(currentActorContextPropsStructure).isRequired,
  }),
  wrappedProps: PropTypes.shape({
    defaultPersonsAtRiskOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    personsAtRiskPolicy: PropTypes.exact({
      canEdit: PropTypes.bool.isRequired,
      canIndex: PropTypes.bool.isRequired,
    }).isRequired,
    riskRegisterPolicy: PropTypes.exact({
      canShow: PropTypes.bool.isRequired,
    }).isRequired,
    seedContentRegister: PropTypes.shape({
      data: resourceShape('contentRegister').isRequired,
      included: PropTypes.arrayOf(resourceShape(contentRegisterResourceTypes))
        .isRequired,
    }).isRequired,
  }).isRequired,
};
